var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccounts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.5,9.1l-13-7c-0.3-0.2-0.7-0.2-0.9,0l-13,7C2.2,9.3,2,9.6,2,10v3c0,0.6,0.4,1,1,1h26c0.6,0,1-0.4,1-1v-3 C30,9.6,29.8,9.3,29.5,9.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,24c0.6,0,1-0.4,1-1v-7c0-0.6-0.4-1-1-1h-2c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1H17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,24c0.6,0,1-0.4,1-1v-7c0-0.6-0.4-1-1-1h-2c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1H25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,24c0.6,0,1-0.4,1-1v-7c0-0.6-0.4-1-1-1H7c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1H9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29,25H3c-0.6,0-1,0.4-1,1v3c0,0.6,0.4,1,1,1h26c0.6,0,1-0.4,1-1v-3C30,25.4,29.6,25,29,25z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounts);
export default __webpack_public_path__ + "static/media/accounts.eeb234808b8eab0474efeedf2d0c213f.svg";
export { ForwardRef as ReactComponent };